import {applyTemplate, displayTrackingMessage, displayPlayBtn, displaySpinnerBtn, displayPlayMsgEl, isPlayVisible} from "../utils/utils";
import Clappr from "@clappr/player";
import {UnmuteButton, ViewerCounterUI} from "../utils/ms-unmute-button";
const axios = require("axios");

const lowConnTimeout = 20;
const failTimeout = 10;
const maxStableConn = 5;
const maxStartupRetries = 12;

export class VideoStateMgrGen {
    viewerCounter = null;

    constructor(autoplay, restMS, displayErrorPanel, restartPlayer) {
        this.autoplay = autoplay;
        this.streamState = "none";
        this.player = null;
        this.playerCore = null;
        this.restMS = restMS;
        this.showMutedMsg = autoplay == 'MUTEONLY';
        this.failState = 0;
        this.retriesConn = 0;
        this.stableConn = maxStableConn;
        this.timeoutOffline = null;
        this.timeoutValidateState = null;
        this.timeoutStreamState = null;
        this.displayErrorPanel = displayErrorPanel;
        this.restartPlayer = restartPlayer;
        this.startupRetryTimeout = null;
        this.startupRetryCount = 0;
        this.trackingTimers = [];
        this.viewerCountHandler = null;
        this.disposed = false;
        console.log('---------> AUTOPLAY', this.autoplay);
        console.log(restMS);
    }

    stopInterval() {
        console.log('--------- stop Interval');
        clearInterval(this.timeoutValidateState);
        this.timeoutValidateState = null;
        clearInterval(this.timeoutOffline);
        this.timeoutOffline = null;
        clearInterval(this.timeoutStreamState);
        this.timeoutStreamState = null;
        clearTimeout(this.startupRetryTimeout);
        this.startupRetryTimeout = null;

        if (this.disposed) {
            return;
        }
        this.restMS.sendAndGetTrackingData(this.isWatching());
    }

    // Count the viewer only while the video is actually playing: not before they
    // press play, and not while paused or stopped.
    isWatching() {
        try {
            return !!this.player && this.player.isPlaying();
        } catch (e) {
            return false;
        }
    }

    clearTrackingTimers() {
        this.trackingTimers.forEach((timer) => {
            clearTimeout(timer);
            clearInterval(timer);
        });
        this.trackingTimers = [];
    }

    // Called when the player component goes away (including the remount on every
    // restart): stop all timers and listeners of this manager without pinging.
    dispose() {
        this.disposed = true;
        this.stopInterval();
        this.clearTrackingTimers();
        if (this.viewerCountHandler) {
            window.removeEventListener('viewer-count', this.viewerCountHandler);
            this.viewerCountHandler = null;
        }
    }

    setPlayer(player, start = false) {
        this.player = player;
        this.playerCore = player.core;
        displaySpinnerBtn(this.player);
        this.stopInterval();
        this.clearTrackingTimers();

        applyTemplate(this.player, this.autoplay != 'DISABLE');

        const stream_data_string = stream_payload.attributes["data-stream-data"].value;
        const stream_data = JSON.parse(stream_data_string);
        console.log( '-----------STREAM DATA-----------');
        console.log(stream_data);
        console.log( '-----------STREAM DATA END-----------');

        if( stream_data.hasOwnProperty('td') && stream_data.hasOwnProperty('tz') ) {
            if( stream_data.td.hasOwnProperty('track_type') ) {
                // stream_data.td = {
                //     "track_type": "specific",
                //     "track_message": "Please confirm youre watching",
                //     "track_period": "10",
                //     "track_period_unit": "m",
                //     "track_delay": "45",
                //     "track_delay_unit": "s",
                //     "track_specific_times": [
                //         "1743129600",
                //         "1743135000",
                //         "1743139200"
                //     ]
                // };

                const track_type = stream_data.td.track_type;
                const trackingData = stream_data.td;
                const timezone = stream_data.tz || 'America/New_York';
                const currentTime = Date.now();

                const application_name = stream_data.application;
                const stream_name = stream_data.stream;
                const stream_id = parseInt(stream_data.vm_stream_id);

                const sendResponse = "https://msstate.member-streaming.live/ping.png";

                const trackPeriodMs = parseInt(trackingData.track_period) * (trackingData.track_period_unit === "m" ? 60000 : 1000);
                const trackDelayMs = parseInt(trackingData.track_delay) * (trackingData.track_delay_unit === "m" ? 60000 : 1000);

                const trackSpecificTimes = (() => {
                    const value = trackingData.track_specific_times;
                    if (!value) return [];
                    if (Array.isArray(value)) return value;
                    if (typeof value === 'string') {
                        const trimmed = value.trim();
                        if (!trimmed || trimmed === '[]') return [];
                        try {
                            const parsed = JSON.parse(trimmed);
                            return Array.isArray(parsed) ? parsed : [];
                        } catch (e) {
                            console.error('Failed to parse track_specific_times', e);
                            return [];
                        }
                    }
                    return [];
                })();

                console.log("USER TRACKING------------>>>");
                console.log( stream_data.td );
                console.log("USER TRACKING------------>>>");

                const showTrackingMessage = (timestamp) => {
                    const messageContainerId = `tracking_message_${timestamp}`;
                    console.log('showing tracking message=', messageContainerId );

                    displayTrackingMessage(this.player, messageContainerId, timestamp, `<div id='${messageContainerId}' class='tracking-modal' style='display:flex;max-width: 300px;left:0;right: 0;margin-left:auto;margin-right:auto;background-color:#64baff;padding:15px;border-radius:2.5px;'>
                            <div class='tracking-message' style='width:100%;flex:1;color:white;line-height:40px;text-align:left;'>${trackingData?.track_message}</div>
                            <div class='tracking-ack' style='width:120px;'>
                                <button style='height:40px;width:100%;border-style:none;background-color:#002e99;color:white;border-radius:2.5px;'>Yes</button>
                            </div>
                        </div>`, trackDelayMs, async (button, index, trackid) => {
                        //console.log('clicked recieved', index, trackid);

                        let userData = await this.restMS.identifyUser(stream_id, application_name, stream_name, stream_data);
                        //console.log('userData', userData);

                        // we have to modify the v_type as this is a response
                        userData.v_type = 'S';
                        userData.v_method = track_type === 'period' ? 'P' : 'T';
                        userData.v_time = trackid;

                        // build a fresh URL per click (appending to a shared URL broke the second ack)
                        const queryString = new URLSearchParams(userData).toString();
                        const ackUrl = queryString.length > 0 ? sendResponse + "?" + queryString : sendResponse;

                        try {
                            await axios.get( ackUrl, {
                                crossDomain: true,
                            } );
                        } catch (e) {
                            console.error('tracking ack failed', e);
                        }
                    });
                }

                console.log('TRACK TYPE=', track_type );
                console.log('TRACK TIME=', trackPeriodMs );

                if( track_type === 'period' ) {
                    const startPeriodTracking = () => {
                        showTrackingMessage(Date.now());
                        this.trackingTimers.push(setInterval(() => {
                            showTrackingMessage(Date.now());
                        }, trackPeriodMs ));
                    };
                    if (trackDelayMs > 0) {
                        this.trackingTimers.push(setTimeout(startPeriodTracking, trackDelayMs));
                    } else {
                        startPeriodTracking();
                    }
                    console.log('TRACK INTERVAL=', trackPeriodMs, 'TRACK DELAY=', trackDelayMs );
                } else if (track_type === 'specific') {
                    if (trackSpecificTimes.length > 0) {
                        trackSpecificTimes.forEach(timeString => {
                            if (timeString == null || String(timeString).trim() === '') return;

                            try {
                                const targetTime = parseInt(timeString, 10) * 1000;

                                if(isNaN(targetTime)) {
                                    console.error(`Invalid timestamp format: ${timeString}`);
                                    return;
                                }

                                let timeUntilTarget = targetTime - currentTime;

                                // ignore past-time
                                if(timeUntilTarget < 0) {
                                    //console.log(`Skipping past time: ${timeString}`);
                                    return;
                                }

                                // show message on time
                                const targetDate = new Date(targetTime);
                                console.log(`Scheduling tracking for ${targetDate.toLocaleString()} (in ${timeUntilTarget}ms)`);
                                this.trackingTimers.push(setTimeout(() => {
                                    showTrackingMessage(targetTime);
                                }, timeUntilTarget));
                            } catch(e) {
                                console.error(`Error processing time: ${timeString}`, e);
                            }
                        });
                    } else {
                        console.error('track_specific_times is empty or invalid');
                    }
                }
            }
        }

        if (start) {
            this.player.core.listenTo(this.player.core.activeContainer, Clappr.Events.CONTAINER_ERROR, (e) => {
                if (!this.player.core.activeContainer) return;
                this.setErrorCallback(e);
            });
            let videoEl = this.player.core.el.querySelector('video');
            if (videoEl) {
                videoEl.addEventListener('stalled', (e) => {
                    // If stalled and running, check stream is active and running and show error message if needed
                    console.log('stalled --->', e, this.streamState);
                    if (this.streamState === 'running' || this.streamState === 'presenterStop') {
                        // Wait 5 seconds for ping to avoid bad connect stalled events.
                        setTimeout(() => {
                            if (this.disposed) return;
                            console.log('setPlayer');

                            this.restMS.checkStreamEngine().then((resp) => {
                                if (this.disposed) return;
                                console.log(1);
                                console.log(JSON.stringify(resp));
                                console.log('Resp ->', resp.running);
                                // just show error if still running.
                                if (this.streamState !== 'inactive' && !resp.running) {
                                    this.player.stop();
                                    this.checkStreamState('stream_completed', 'inactive');
                                }
                            }).catch((err) => {
                                this.streamState = 'none'
                                this.stopInterval();
                                this.displayErrorPanel('stream_error', 'gotError');
                            });
                        }, 5000);
                    }
                });
                videoEl.addEventListener("webkitendfullscreen", () => {
                    console.log('CLOSE FULLSCREEN!!');
                    this.player.play();
                }, false);
                videoEl.addEventListener('ended', function (e) {
                    console.log('----- ended');
                });
            }
            this.streamState = 'ready';
            this.loadEvents();
            this.player.play();
            if (this.autoplay == 'DISABLE') {
                this.player.stop();
            }
            this.timeoutValidateState = setInterval(() => {
                this.validateState();
            }, 3000);
        }
    }

    validateState() {
        let self = this;
        clearInterval(this.timeoutValidateState);
        if (this.disposed || this.streamState == 'disabled') {
            return;
        }
        let state = this.playerCore.activePlayback.el.readyState;
        // 0 or default
        // HAVE_NOTHING
        // 1 -> HAVE_METADATA
        // 2 -> HAVE_CURRENT_DATA
        // 3 -> HAVE_FUTURE_DATA
        // 4 -> HAVE_ENOUGH_DATA
        switch (state) {
            case 0:
                if (this.streamState != 'presenterStop' && this.streamState != 'stopped' &&
                    this.streamState != 'inactive' && this.streamState != 'offline') {
                    console.log('Fail State -->', this.failState);
                    if (this.failState == 0) {
                        this.failState = Date.now();
                    } else if ((Date.now() - this.failState) > (failTimeout * 1000)) {
                        this.failState = 0;
                        if (this.streamState === 'starting' || this.streamState === 'gotError' ||
                            this.streamState === 'retry') {
                            this.scheduleStartupRetry();
                        } else {
                            this.player.play();
                        }
                    }
                }
                break;
            case 1:
            case 2:
                if (this.streamState === 'running') {
                    if (this.retriesConn > -1) {
                        console.log("validateState")
                        this.restMS.checkStreamEngine()
                            .then((resp) => {
                                if (this.disposed) return;
                                this.streamState = 'presenterStop';
                                console.log('Set timeout inactive');
                                this.timeoutOffline = setInterval(() => {
                                    console.log('--> Run timeout inactive');
                                    if (navigator.onLine) {
                                        this.checkStreamState('stream_completed', 'inactive');
                                    } else {
                                        if (this.streamState !== 'offline') {
                                            this.streamState = 'none'
                                            this.stopInterval();
                                            this.displayErrorPanel('internet_error', 'offline');
                                        }
                                    }
                                }, 8000);
                            }).catch((error) => {
                            if (error.status !== 404) {
                                this.streamState = 'none'
                                this.stopInterval();
                                this.displayErrorPanel('stream_error', 'gotError');
                            }
                        });
                    }
                }
                break;
            case 3:
            case 4:
                // just check if stream is running
                if (this.streamState == 'retry') {
                    this.streamState = 'running';
                }
                if (this.streamState == 'starting') {
                    this.mediaPlaying();
                }
                if (this.autoplay == 'DISABLE' && this.streamState == 'ready') {
                    displayPlayMsgEl(this.player);
                }
                if (this.retriesConn > -1 && this.stableConn < maxStableConn) {
                    // reset low connection adn stable connection values if valid retry connection and stable connection equals 5.
                    if (this.stableConn == 4) {
                        this.retriesConn = 0;
                    }
                    // count stable connecton after ready state 2.
                    this.stableConn++;
                }
                break;
            default:
                // just check if stream is running
                if (this.streamState == 'retry') {
                    this.streamState = 'running';
                }
                if (this.streamState == 'starting') {
                    this.mediaPlaying();
                }
                if (this.autoplay == 'DISABLE' && this.streamState == 'ready') {
                    displayPlayMsgEl(this.player);
                }
                if (this.retriesConn > -1 && this.stableConn < maxStableConn) {
                    // reset low connection adn stable connection values if valid retry connection and stable connection equals 5.
                    if (this.stableConn == 4) {
                        this.retriesConn = 0;
                    }
                    // count stable connecton after ready state 2.
                    this.stableConn++;
                }
                break;
        }
        console.log('Resolution', this.player.core.activePlayback.currentLevel, ' - Stream State', this.streamState)
        console.log('---> State:', state, ' - Retries:', this.retriesConn, ' - StableConn:', this.stableConn);
        // check it every 3 seconds.
        this.stopInterval();
        if (this.streamState != 'none' && this.streamState != 'disabled') {
            this.timeoutValidateState = setInterval(() => {
                this.validateState();
            }, 3000);
        }
    }

    loadEvents() {
        console.log('SET EVENTS');
        // Add Event listner for Buffering (readyState 1 - 2), Bufferfull (readyState 3 - 4) and Mediacontrol_playing (player start streaming)
        this.player.listenTo(this.player.core.activeContainer, Clappr.Events.CONTAINER_STATE_BUFFERFULL, (e) => {
            this.stateBufferFull()
        });
        this.player.listenTo(this.player.core.mediaControl, Clappr.Events.MEDIACONTROL_PLAYING, (e) => {
            this.mediaPlaying()
        });
        // Change streamState to stopped when user hit stop button.
        this.player.listenTo(this.player, Clappr.Events.PLAYER_STOP, (e) => {
            if (this.streamState == 'running') {
                this.streamState = 'stopped';
            }
        });
        Clappr.$('div.player-poster.clickable').on('click', (e) => {
            displayPlayMsgEl(this.player, true);
        });
        console.log('---------> UNMUTE!!!');
        this.unmuteButton = new UnmuteButton(this.player);

        const stream_payload = document.getElementById("stream_payload");
        if( stream_payload ) {
            try {
                const stream_data_string = stream_payload.attributes["data-stream-data"].value;
                const stream_data = JSON.parse(stream_data_string);
                const stream_id = parseInt(stream_data.vm_stream_id);

                // viewer counter
                this.viewerCounter = new ViewerCounterUI(this.player);
                this.viewerCounter.init();
                if (this.viewerCountHandler) {
                    window.removeEventListener('viewer-count', this.viewerCountHandler);
                }
                this.viewerCountHandler = (event) => {
                    // only update the relevant stream
                    if( event.detail?.stream_id === stream_id ) {
                        this.viewerCounter.updateCount(event.detail.from, event.detail.to);
                    }
                };
                window.addEventListener('viewer-count', this.viewerCountHandler);
            } catch ( e ) {
                console.error('failed to parse the stream data');
            }
        }
    }

    stateBufferFull() {
        console.log('==> stateBufferFull', this.streamState);
        let self = this;
        // set state to ready
        if (this.streamState !== 'ready' && this.streamState !== 'running' && this.streamState !== 'inactive' && this.streamState !== 'retry') {
            this.streamState = 'ready';
            console.log('READY TO START!');
        }
    }

    mediaPlaying() {
        console.log('==> mediaPlaying', this.streamState);
        console.log("player media is playing .......");


        let self = this;
        if (this.streamState === 'ready') {
            // if ready, set state to running and enable control bar on player
            this.streamState = 'running';
            this.startupRetryCount = 0;
            clearTimeout(this.startupRetryTimeout);
            this.startupRetryTimeout = null;
            // if started on mute, show unmuted button on
            if (this.showMutedMsg && (this.player.getVolume() === 0)) {
                console.log('SHOW MUTE BUTTON');
                this.unmuteButton.showButton();
            }

            this.showMutedMsg = false;
            console.log('VIDEO STARTED!');
            displayPlayBtn(this.player, true);
            displaySpinnerBtn(this.player, true);
            displayPlayMsgEl(this.player, true);
        }
    }

    setErrorCallback(e) {
        var self = this;
        console.log('Got error:', e.code);
        if (this.streamState === 'disabled') {
            return;
        }

        displayPlayBtn(this.player, true);
        displaySpinnerBtn(this.player);

        console.log('-----------> e.code', e.code);
        switch (e.code) {
            case 'hls:networkError_levelLoadError':
                console.log('-----> stream inactive');
                if (this.streamState !== "none" && this.streamState !== "inactive") {
                    this.streamState = 'gotError';
                    // If can't load playlist and online check stream state with server
                    if (navigator.onLine) {
                        this.checkStreamState('stream_completed', 'inactive');
                    } else {
                        // Show offline message
                        if (this.streamState !== 'offline') {
                            this.streamState = 'none'
                            this.stopInterval();
                            this.displayErrorPanel('internet_error', 'offline');
                        }
                    }
                }
                break;
            case 'hls:networkError_manifestParsingError':
                console.log('-----> stream completed');
                // Streaming already started yet try play
                if (this.streamState === "ready" || this.streamState === "starting" ||
                    this.streamState === "retry") {
                    this.player.play();
                    this.streamState = "retry";
                    displayPlayMsgEl(this.player);
                } else if (this.streamState !== "none" && this.streamState !== "inactive") {
                    // if state not none or inactive show inactive error message
                    this.streamState = 'none'
                    this.stopInterval();
                    this.displayErrorPanel('stream_completed', 'inactive');
                }
                break;
            case 'hls:networkError_manifestLoadError':
            case 'hls:networkError_levelLoadTimeOut':
            case 'hls:networkError_manifestLoadTimeOut':
                console.log('-----> connection error');
                // if timeout error and running show slow connection message
                if (this.streamState === 'running') {
                    this.streamState = 'lowConnection';
                    if (this.retriesConn !== -1) {
                        this.checkConnState();
                    }
                } else if (this.streamState === 'starting' || this.streamState === 'ready' ||
                    this.streamState === 'retry' || this.streamState === 'gotError') {
                    // HLS may not be ready yet (simulive cold start) — retry instead of showing inactive
                    console.log('-----> startup HLS retry');
                    this.streamState = 'gotError';
                    this.scheduleStartupRetry();
                } else {
                    // Otherwise check stream state on server and show the proper message
                    if (navigator.onLine) {
                        if (this.streamState !== 'inactive') {
                            this.streamState = 'gotError';
                            this.checkStreamState('stream_completed', 'inactive');
                        }
                    } else { // Offline message
                        if (this.streamState !== 'offline') {
                            this.streamState = 'none'
                            this.stopInterval();
                            this.displayErrorPanel('internet_error', 'offline');
                        }
                    }
                }
                break;
            default :
                console.log('Error:', e.code, e.raw);
                break;
        }
    }

    checkConnState() {
        let self = this;
        let currentLevel = this.player.core.activePlayback.currentLevel;
        // Show slow connection error message with close button.
        if (currentLevel == -1) {
            this.retriesConn = 0;
        } else {
            this.streamState = 'none'
            this.stopInterval();
            this.displayErrorPanel('connection_slow', 'lowConnection');
        }
    }

    destroyPlayer() {
        if (this.player) {
            this.player.destroy();
        }
        this.player = null;
    }

    scheduleStartupRetry() {
        if (this.startupRetryTimeout) {
            return;
        }
        this.startupRetryCount++;
        if (this.startupRetryCount > maxStartupRetries) {
            this.streamState = 'none';
            this.stopInterval();
            this.displayErrorPanel('stream_error', 'gotError');
            return;
        }
        const delay = Math.min(2000 * this.startupRetryCount, 12000);
        console.log('-----> scheduleStartupRetry', this.startupRetryCount, 'delay', delay);
        displaySpinnerBtn(this.player);
        this.startupRetryTimeout = setTimeout(() => {
            this.startupRetryTimeout = null;
            this.restMS.checkStreamEngine().then((resp) => {
                if (this.disposed) return;
                if (resp.running) {
                    this.streamState = 'starting';
                    this.restartPlayer();
                } else {
                    this.checkStreamState('stream_completed', 'inactive');
                }
            }).catch(() => {
                if (this.disposed) return;
                this.scheduleStartupRetry();
            });
        }, delay);
    }

    checkStreamState(showError = '', streamState = '') {
        // tell difference between both checkstreamstate
        let self = this;
        // clearInterval(this.timeoutStreamState);
        self.stopInterval();
        if (this.disposed || this.streamState == 'disabled') {
            return;
        }
        console.log("checkStreamStateGen");
        if (navigator.onLine) {
            console.log('onLine');
            // console.log(self.streamState);
            self.stopInterval();
            self.timeoutStreamState = setInterval(() => {

                this.restMS.checkStreamEngine().then((resp) => {
                    if (self.disposed) return;
                    console.log('----->', 'isRunning', resp.running, ' - streamState', this.streamState);
                    self.validateState();
                    if (resp.running) {
                        if (showError !== '' || self.streamState === 'gotError') {
                            clearInterval(self.timeoutStreamState);
                            self.timeoutStreamState = null;
                            self.streamState = 'starting';
                            self.restartPlayer();
                            return;
                        }
                    } else if (!resp.running) {
                        self.player.core.mediaControl.disable();
                        if (showError !== '') {
                            this.streamState = 'none'
                            self.stopInterval();
                            self.displayErrorPanel(showError, streamState);
                            // Disable show inactive message timeout
                            if (self.timeoutOffline != null) {
                                console.log('Clear TimeoutOffline.');
                                clearInterval(self.timeoutOffline);
                                self.timeoutOffline = null;
                            }
                        } else {
                            self.destroyPlayer();
                            self.restartPlayer();
                        }
                    }
                    // self.displayErrorPanel(showError, streamState);
                }).catch((err) => {
                    if (self.disposed) return;
                    console.log("ERRR")
                    console.log(err);
                    self.stopInterval();
                    this.timeoutStreamState = setInterval(() => {
                        self.checkStreamState();
                    }, 3000);
                });
            }, 3000);
        } else {
            clearInterval(this.checkRunning);
            this.checkRunning = null;
            console.log("offline");
        }
    }
}
